export default __webpack_public_path__ + "static/media/Techastra-Ph1 1.510404c8.png";